import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  actionUserAdd,
  actionUserAuth,
  actionUserResetPassword,
  actionUserForgotPassword,
  actionUserSignOut,
} from "../../actions/";
import { Row, Col, Input, Button, message, Tabs } from "antd";
import { InputGroup } from "../../components";
import "./Login.css";

const { TabPane } = Tabs;

const mapStateToProps = (state, ownProps) => {
  if (state) {
    return state;
  } else {
    return null;
  }
};

const mapDispatchToProps = {
  actionUserAdd,
  actionUserAuth,
  actionUserResetPassword,
  actionUserForgotPassword,
  actionUserSignOut,
};

function Login(props) {
  const code = new URLSearchParams(window.location.search).get("code");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showSignUpMessage, setShowSignUpMessage] = useState(false);

  const handleLogin = () => {
    if (email !== "" && password !== "") {
      props
        .actionUserAuth({
          identifier: email,
          password: password,
        })
        .then(() => {
          props.history.push(`/`);
        })
        .catch(() => {
          message.error(
            "Sorry, try again: that email & password combination was not found."
          );
        });
    } else {
      message.error("Please enter your email and password.");
    }
  };

  const handleSignUp = () => {
    if (password !== "" && password === confirmPassword) {
      props
        .actionUserAdd({
          username: email,
          email: email,
          password: password,
        })
        .then((res) => {
          return props.actionUserAuth({
            identifier: email,
            password: password,
          });
        })
        .then(() => {
          props.history.push(`/`);
        })
        .catch((err) => {
          message.error(
            "This account could not be created. Have you already registered an account with this email address?"
          );
        });
    } else {
      message.error("Passwords must match");
    }
  };

  const handleForgotPassword = () => {
    if (!email) {
      message.error("Please enter your email to reset your password.");
      return;
    }
    props
      .actionUserForgotPassword({
        email,
      })
      .then(() => {
        message.error("Check your email for reset instructions.");
        props.history.push(`/`);
      })
      .catch(() => {
        message.error("Sorry, we couldn't reset your password");
      });
  };

  const handleResetPassword = () => {
    if (password) {
      props
        .actionUserResetPassword({
          code: code,
          password: password,
          passwordConfirmation: password,
        })
        .then(() => {
          props.history.push(`/`);
        })
        .catch(() => {
          message.error(
            "Sorry, try again: that email & password combination was not found."
          );
        });
    }
  };

  const tabsCallback = (key) => {
    if (key === "2") {
      setShowSignUpMessage(true);
    } else {
      setShowSignUpMessage(false);
    }
  };

  return (
    <div className="row row--map-background">
      <div className="row__col row__col--form">
        <div className="row__content">
          <img
            className="row__logo-image"
            src="/assets/tree-equity-score-logo-analyzer.svg"
            alt="tree equity score logo"
            width="175"
            height="122"
          />
          {code ? (
            <>
              <h1 className="row__heading">Reset your password</h1>

              <div className="row__form-content">
                <InputGroup label="Password" variant="clean" type="primary">
                  <Input.Password
                    onPressEnter={handleResetPassword}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                </InputGroup>
              </div>

              <Button onClick={handleResetPassword} type="primary" size="large">
                RESET
              </Button>
            </>
          ) : (
            <>
              <h1 className="row__heading">
                Help achieve Tree Equity in Rhode Island
              </h1>
              <Tabs defaultActiveKey="1" onChange={tabsCallback}>
                <TabPane tab="Login" key="1">
                  <div className="row__form-content">
                    <InputGroup
                      label="Email Address"
                      variant="clean"
                      type="primary"
                    >
                      <Input
                        type="email"
                        value={email}
                        placeholder="Email address"
                        onPressEnter={handleLogin}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </InputGroup>

                    <InputGroup label="Password" variant="clean" type="primary">
                      <Input.Password
                        onPressEnter={handleLogin}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </div>

                  <Row align="middle">
                    <Col xs={{ span: 12 }}>
                      <Button onClick={handleLogin} type="primary" size="large">
                        LOGIN
                      </Button>
                    </Col>

                    <Col xs={{ span: 12 }}>
                      <Button type="link" onClick={handleForgotPassword}>
                        Forgot password
                      </Button>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="Sign Up" key="2">
                  <div className="row__form-content">
                    <InputGroup
                      label="Email Address"
                      variant="clean"
                      type="primary"
                    >
                      <Input
                        type="email"
                        value={email}
                        placeholder="Email address"
                        onPressEnter={handleSignUp}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </InputGroup>

                    <InputGroup label="Password" variant="clean" type="primary">
                      <Input.Password
                        onPressEnter={handleSignUp}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                    </InputGroup>

                    <InputGroup
                      label="Confirm Password"
                      variant="clean"
                      type="primary"
                    >
                      <Input.Password
                        onPressEnter={handleSignUp}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </div>

                  <Button type="primary" size="large" onClick={handleSignUp}>
                    SIGN UP
                  </Button>
                </TabPane>
              </Tabs>
            </>
          )}
        </div>
      </div>
      <div className="row__col row__col--message">
        {showSignUpMessage && (
          <div className="row__well">
            <ul className="unordered-list">
              <li className="unordered-list__item">
                Explore Rhode Island, across municipalities, city parcels, and
                more.
              </li>
              <li className="unordered-list__item">
                Dive deep with environmental, climate, demographic, and health
                data.
              </li>
              <li className="unordered-list__item">
                Select neighborhoods or parcels and draw your own custom site
                boundaries.
              </li>
              <li className="unordered-list__item">
                Build, save, and share custom tree planting scenarios.
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);

export default withRouter(LoginContainer);
